{#if composeBox}
  <svelte:component this={composeBox} {realm} {hidden} />
{/if}
<script>
  import { importComposeBox } from '../../_utils/asyncModules/importComposeBox.js'
  import { importLoggedInStoreExtensions } from '../../_utils/asyncModules/importLoggedInStoreExtensions.js'

  export default {
    async oncreate () {
      const [composeBox] = await Promise.all([
        importComposeBox(),
        importLoggedInStoreExtensions()
      ])
      this.set({ composeBox })
    },
    data: () => ({
      composeBox: undefined
    })
  }
</script>
